import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../data/images';

const TrustLayer = () => {
  const { t } = useLanguage();

  // 20 Baltic client logos
  const clients = [
    'Riga Water Utility',
    'Vilnius Airport',
    'Tallinn Central Library',
    'Baltic Energy Group',
    'Nordic Logistics LT',
    'Smart City Riga',
    'Latvijas Gāze',
    'Kaunas Municipality',
    'Tartu University Hospital',
    'Liepāja Port Authority',
    'Estonian Railways',
    'Vilnius University',
    'Rīgas Satiksme',
    'Klaipėda Seaport',
    'Tallinn Airport',
    'Latvian National Library',
    'Baltic Hospitals Network',
    'Riga Technical University',
    'Lithuanian Airports',
    'Estonian Energy AS'
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <img
          src={images.hero.trust}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900">
          {t.trust.title}
        </h2>

        {/* Scrolling Logo Carousel */}
        <div className="relative">
          <div className="logo-carousel-container overflow-hidden">
            <div className="logo-carousel-track flex gap-8 animate-scroll">
              {/* First set */}
              {clients.map((client, index) => (
                <div
                  key={`first-${index}`}
                  className="bg-white px-6 py-3 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-200 flex-shrink-0 min-w-[200px]"
                >
                  <span className="text-base font-semibold text-gray-700 whitespace-nowrap">{client}</span>
                </div>
              ))}
              {/* Duplicate set for seamless loop */}
              {clients.map((client, index) => (
                <div
                  key={`second-${index}`}
                  className="bg-white px-6 py-3 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-200 flex-shrink-0 min-w-[200px]"
                >
                  <span className="text-base font-semibold text-gray-700 whitespace-nowrap">{client}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        
        .logo-carousel-track:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default TrustLayer;